/** Un evento è un preventivo finché la cliente non accetta o non lo si conferma a mano. */
export function isQuote(event: any): boolean {
  return event?.event?.status === 'quote';
}

/** Evento confermato (preventivo accettato online) a cui manca ancora il giorno. */
export function needsDate(event: any): boolean {
  return !!event?.event && !isQuote(event) && !event.event.date;
}

/** Note dell'evento, solo se si è scelto di mostrarle alla cliente. */
export function clientNotes(event: any): string {
  const note = event?.event?.note;
  return note?.show_client ? (note.text ?? '').trim() : '';
}

/** Dicitura "il prezzo potrà variare" nel preventivo: mostrata salvo scelta contraria. */
export function hasPriceDisclaimer(event: any): boolean {
  return event?.event?.quote_disclaimer !== false;
}
